import { Popover, Button } from '@nackle/paper';
import { Link } from '@reach/router';
import { MenuItemLink } from 'components/header/MenuItemLink';
import React from 'react';

export const HeaderButtonLink = (props: any) => {

    const { 
        link,
        parentPath,
        pathname
    } = props;

    const href = parentPath + link.path;
    const active = pathname?.startsWith(href) ? 'active' : '';
    const iconClass = link.icon ? 'nkl-icon' : '';

    let linkElement = (
        <Link
            className={`menu-link ${active} ${iconClass}`}
            to={href}
            id={link.id}
        >
            <Button target={href} size="large" icon={link.icon} className="menu-button" type="primary">
                {link.label}
            </Button>
        </Link>
    );

    if (link.children) {
        const childLinks = link.children.map(child =>
            <MenuItemLink key={child.path} link={child} parentPath={href} pathname={pathname ? pathname : ''} />
        );

        linkElement = (
            <div className="nkl-popover-wrapper">
            <Popover
                content={childLinks}
                trigger="hover"
                autoAdjustOverflow
                destroyTooltipOnHide
                placement="bottom"
                arrowPointAtCenter={false}
            >
                {linkElement}
            </Popover>
            </div>
        );
    }
    return linkElement;
};
